import { render, staticRenderFns } from "./UptoDateGrade.vue?vue&type=template&id=46dcfe16&scoped=true"
import script from "./UptoDateGrade.vue?vue&type=script&lang=js"
export * from "./UptoDateGrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dcfe16",
  null
  
)

export default component.exports